<div class="pad">
    <div *ngIf="user['status'] == 'approved' " class="profile">
        <header>
            <p>Hello {{user['name'] | titlecase}}</p>
        </header>
        <div *ngIf="!(user['role'] == 'staff')" class="wallet">
            <button mat-raised-button (click)="fundWallet()" class="flex" style="font-size: 3rem; font-weight: bold;"
                color="accent">
                <mat-icon class="mat-18"
                    style="color: #fff; font-size: 2rem; width: 2rem; height: 2rem;">account_balance_wallet</mat-icon>
                Fund Wallet
            </button>
            <h4>Balance: {{walletBalance['balance'] | currency:"₦ "}}</h4>
        </div>
    </div>

    <br>
    <div *ngIf="(user['status'] == 'pending') && !user['cac_number']">
        <div>

            <div class="contShadow sMbdrRad" style="padding: 1em;background-color: white;">
                <div>
                    <h3 style="margin-bottom: 5px">
                        Welcome🖐... let's get you started.
                    </h3>
                    <h5 style="border-bottom: 1px solid var(--primary-color);padding-bottom: 10px;">
                        Please fill the form below to continue your onboarding process.
                    </h5>
                    <!-- <hr style="border-color: var(--primary-color);"> -->
                    <br><br>
                    <div *ngIf="user['role'] !== 'staff'">
                        <form  *ngIf="!isCacDetails" [formGroup]="form" (ngSubmit)="getCacDetails()" class="flex" style="justify-content: start; gap:30px;">
                            <mat-form-field>
                                <mat-label>CAC No. . . RC123456</mat-label>
                                <input type="text" matInput formControlName="cac_number">
                            </mat-form-field>
                            <button [disabled]="!form.controls.cac_number.valid" mat-flat-button color="accent">Submit</button>
                        </form>
                        <form *ngIf="isCacDetails" [formGroup]="form" >
                            <div class="flex pad" style="align-items: start; justify-content: space-between;gap: 20px;">
                                <div>
                                    <mat-form-field>
                                        <mat-label>Company Name</mat-label>
                                        <input type="text" formControlName="name" matInput>
                                    </mat-form-field>
                                </div>
        
                                <div>
        
                                    <mat-form-field>
                                        <mat-label>Phone</mat-label>
                                        <input type="tel" formControlName="phone" matInput>
                                    </mat-form-field>
                                </div>
                                <div>
                                    <mat-form-field>
                                        <mat-label>CAC No</mat-label>
                                        <input type="text" formControlName="cac_number" matInput>
                                    </mat-form-field>
                                </div>
                                <div>
                                    <div>
                                        <mat-label>Upload CAC Certificate</mat-label>
                                        <br>
                                        <input type="file" accept="application/pdf, .jpg,.png,.jpeg" (change)="selectIm($event)" name="">
                                    </div>
                                </div>
                            </div>
                            <div class="flex pad" style="justify-content: start;"> <mat-form-field>
        
                                    <mat-label>Address</mat-label>
                                    <textarea matInput placeholder="" formControlName="address"></textarea>
                                </mat-form-field>
        
                                <!-- <div class="flex" style="justify-content: end;"> -->
                                    <button  mat-stroked-button style="margin-left: 20px;" color="accent"
                                    (click)="isCacDetails =! isCacDetails; form.controls.cac_number.enable();">Back</button>
                                <button [disabled]="!form.valid" mat-flat-button style="margin-left: 20px;" color="accent"
                                    (click)="submit()">Submit</button>
                                <!-- </div> -->
                            </div>
                            <!-- <mat-form-field> -->
        
                            <!-- </mat-form-field> -->
        
                        </form>
                    </div>

                    <!-- <form [formGroup]="form"  *ngIf="user['role'] === 'staff'">
                        <div class="flex pad" style="align-items: center; justify-content: start;gap: 10px;">
                            <div>
                                <mat-form-field>
                                    <mat-label>Name</mat-label>
                                    <input type="text" formControlName="name" matInput>
                                </mat-form-field>
                            </div>
    
                            <div>
    
                                <mat-form-field>
                                    <mat-label>Phone</mat-label>
                                    <input type="tel" formControlName="phone" matInput>
                                </mat-form-field>
                            </div>
                            <div>
                                     <mat-form-field>
    
                                <mat-label>Address</mat-label>
                                <textarea matInput placeholder="" formControlName="address"></textarea>
                            </mat-form-field>
                            </div>
                            <div>
                                <button [disabled]="!form.valid" mat-flat-button style="margin-left: 20px;" color="accent"
                                (click)="submit()">Submit</button>
                            </div>
                            <div>
                                <mat-form-field>
                                    <mat-label>CAC No</mat-label>
                                    <input type="text" formControlName="cac_number" matInput>
                                </mat-form-field>
                            </div>
                            <div>
                                <div>
                                    <mat-label>Upload CAC Certificate</mat-label>
                                    <br>
                                    <input type="file" accept="application/pdf, .jpg,.png,.jpeg" (change)="selectIm($event)" name="">
                                </div>
                            </div>
                        </div>
                        <div class="flex pad" style="justify-content: start;"> 
                       
    
                            <div class="flex" style="justify-content: end;">
                                
                            
                            </div>
                        </div>
                        <mat-form-field>
    
                        </mat-form-field>
    
                    </form> -->
                </div>
            </div>
        </div>
        <!-- </div> -->
    </div>
    <div *ngIf="(user['role'] == 'staff')">
        <div style="background-color: white;padding: 20px;" class="sMbdrRad contShadow">
            <div class="detailsBox sMbdrRad">
                <div class="flex" style="justify-content: space-between;">

                    <h3 style="color: var(--secondary-color);">{{user['name'] | titlecase}}</h3>
                    <div style="justify-content: end;">

                        <p *ngIf="user['status'] == 'pending'" class="pending">Pending</p>
                        <p *ngIf="user['status'] == 'approved'" class="approved">Approved</p>

                    </div>
                </div>
                <br>
                <div class="flex fg">
                    <div style="flex: 1;">
                        <p>Staff Name.</p>
                        <h3>{{user['name'] | uppercase}}</h3>
                    </div>
                    <div style="flex: 1;">
                        <p>Email</p>
                        <h3>{{user['email'] | titlecase}}</h3>
                    </div>
                    <div style="flex: 1;">
                        <p>Phone No.</p>
                        <h3>{{user['phone']}}</h3>
                    </div>
                </div>
                <br>
                <!-- <div>
                    <div class="flex fg">
                        <div style="flex: 1;">
                            <p>CAC NO:</p>
                            <h3>{{user['cac_number']}}</h3>

                        </div>
                        <div style="flex: 1;">
                            <p>CAC Certificate</p>
                            <a style="color: var(--primary-color);" href="{{user['cac_upload']}}" target="_blank"
                                rel="noopener noreferrer">View</a>
                        </div>
                        <div style="flex: 1;">
                        </div>
                    </div>

                </div> -->
                <br>
            </div>
        </div>
    </div>
    <div *ngIf="(user['status'] != 'queried') && (user['cac_number'])">
        <div style="background-color: white;padding: 20px;" class="sMbdrRad contShadow">
            <div class="detailsBox sMbdrRad">
                <div class="flex" style="justify-content: space-between;">

                    <h3 style="color: var(--secondary-color);">{{user['name'] | titlecase}}</h3>
                    <div style="justify-content: end;">

                        <p *ngIf="user['status'] == 'pending'" class="pending">Pending</p>
                        <p *ngIf="user['status'] == 'approved'" class="approved">Approved</p>

                    </div>
                </div>
                <br>
                <div class="flex fg">
                    <div style="flex: 1;">
                        <p>Company Name.</p>
                        <h3>{{user['name']}}</h3>
                    </div>
                    <div style="flex: 1;">
                        <p>Email</p>
                        <h3>{{user['email'] | titlecase}}</h3>
                    </div>
                    <div style="flex: 1;">
                        <p>Phone No.</p>
                        <h3>{{user['phone']}}</h3>
                    </div>
                </div>
                <br>
                <div>
                    <div class="flex fg">
                        <div style="flex: 1;">
                            <p>CAC NO:</p>
                            <h3>{{user['cac_number']}}</h3>

                        </div>
                        <div style="flex: 1;">
                            <p>CAC Certificate</p>
                            <a style="color: var(--primary-color);" href="{{user['cac_upload']}}" target="_blank"
                                rel="noopener noreferrer">View</a>
                        </div>
                        <div style="flex: 1;">
                        </div>
                    </div>

                </div>
                <br>
            </div>
        </div>
    </div>
    <div *ngIf="user['status'] == 'queried'">
        <div>

            <div class="contShadow sMbdrRad" style="padding: 1em;background-color: white;">
                <div>
                    <div style="border-bottom: 1px solid var(--primary-color);padding-bottom: 10px;">
                        <h3>Your submission was queried</h3>

                        <br><br>
                        <p *ngFor="let comment of user['comments']">{{comment}}</p>
                    </div>
                    <!-- <hr style="border-color: var(--primary-color);"> -->
                    <br><br>
                    <form [formGroup]="form">
                        <div class="flex pad" style="align-items: start; justify-content: space-between;">
                            <div>

                                <mat-form-field>
                                    <mat-label>Company Name</mat-label>
                                    <input type="text" formControlName="name" matInput>
                                </mat-form-field>
                            </div>

                            <div>

                                <mat-form-field>
                                    <mat-label>Phone</mat-label>
                                    <input type="tel" maxlength="11" minlength="11" formControlName="phone" matInput>
                                    <mat-error *ngIf="form.controls.phone.errors ">Phone Number must not be more 11
                                        digits</mat-error>

                                </mat-form-field>
                            </div>
                            <div>
                                <mat-form-field>
                                    <mat-label>CAC No</mat-label>
                                    <input type="number" formControlName="cac_number" matInput>
                                </mat-form-field>
                            </div>
                            <div>
                                <div>
                                    <a style="color: var(--primary-color);" [href]="user['cac_upload']" target="_blank"
                                        rel="noopener noreferrer">View Current CAC Certificate</a>
                                    <br>
                                    <br>
                                    <mat-label>Upload CAC Certificate</mat-label>
                                    <br>
                                    <input type="file" accept="application/pdf, .jpg,.png,.jpeg"
                                        (change)="selectIm($event)" name="">
                                </div>
                            </div>
                        </div>
                        <div class="flex pad add" style="justify-content: start;">
                            <mat-form-field>
                                <mat-label>Address</mat-label>
                                <textarea matInput placeholder="" formControlName="address"></textarea>
                            </mat-form-field>
                            <button mat-flat-button [disabled]="!form.valid" style="margin-left: 20px;" color="accent"
                                (click)="submitQuery()">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- </div> -->
    </div>

</div>